<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('pages') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_page')"
        :loading="savingPage"
        :saving="savingPage"
        @click="initPage"
      />
    </div>

    <div>
      <v-row v-if="pages && !loadingPages" class="responsive-tree">
        <v-col
          v-for="(pages, type) in groupedPagesByType"
          :key="type"
          cols="12"
          sm="5"
          class="custom-tree-view"
        >
          <h1 v-if="type !== 'null'" class="text-h6 pa-4">{{ $t(type) }}</h1>

          <h1 v-else class="text-h6 pa-4 grey--text">
            {{ $t('no_type') }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="ml-2" small>mdi-information</v-icon>
              </template>
              <span>{{ $t('no_type_selected') }}</span>
            </v-tooltip>
          </h1>

          <PagesTreeView
            :items="pages"
            @edit="$router.push({ name: 'editPages', params: { id: $event.id } })"
            @delete="deletePage"
          />
        </v-col>
      </v-row>
      <v-progress-circular
        v-else
        :size="70"
        color="primary"
        class="ml-4"
        indeterminate
      ></v-progress-circular>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import PagesTreeView from '../../components/PagesTreeView';

export default {
  name: 'Pages',

  components: { PagesTreeView, BasePrimaryActionButton },

  created() {
    if (!this.pages) {
      this.fetchPages(this.$route.query);
    }
  },

  computed: {
    ...mapState('pages', ['pages', 'loadingPages', 'savingPage']),

    groupedPagesByType() {
      const pagesByType = {
        projects: [],
        trainings: [],
        preterm_birth: [],
        premature_baby: [],
        already_at_home: [],
        lost_baby: [],
      };

      for (let i = 0; i < this.pages?.length; i++) {
        if (pagesByType[this.pages[i].type]) {
          pagesByType[this.pages[i].type].push(this.pages[i]);
        } else {
          pagesByType[this.pages[i].type] = [this.pages[i]];
        }
      }
      return pagesByType;
    },
  },

  methods: {
    ...mapActions('pages', ['fetchPages', 'storePage', 'deletePage']),

    initPage() {
      this.storePage().then((res) => {
        this.$router.push({ name: 'editPages', params: { id: res.data.id } });
      });
    },
  },
};
</script>

<style scoped>
.custom-tree-view {
  border: 1px solid #ccc;
  margin: 20px auto;
  min-height: 250px;
  font-size: 14px;
}
@media (max-width: 599px) {
  .responsive-tree {
    margin: auto;
    width: 90%;
  }
}
</style>
